import { useTranslation } from 'react-i18next';

export default function SafetySection() {
  const { t } = useTranslation();

  return (
    <section id="safety" className="bg-secondary-100/60">
      <div className="mx-auto w-full max-w-7xl px-4 py-16 md:px-6 md:py-24">
        <div className="mx-auto max-w-3xl rounded-lg border border-secondary-200/70 bg-white p-8 text-center md:p-12">
          <span className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-secondary-100 text-secondary-600">
            <i className="ri-shield-check-line text-2xl" />
          </span>
          <h2 className="mt-5 font-heading text-2xl font-semibold text-foreground-950 md:text-3xl">
            {t('safety_title')}
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">{t('safety_desc')}</p>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="mt-7 inline-flex items-center gap-2 rounded-full bg-secondary-500 px-6 py-3 text-sm font-semibold text-white transition-colors hover:bg-secondary-600 whitespace-nowrap cursor-pointer"
          >
            {t('safety_cta')}
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line" />
            </span>
          </a>
        </div>
      </div>
    </section>
  );
}